import en from './en'
import zh from './zh'

export default {
  en,
  zh
}



// WEBPACK FOOTER //
// ./src/common/lang/index.js